import { render, staticRenderFns } from "./SiteDocumentNew.vue?vue&type=template&id=320203e6"
import script from "./SiteDocumentNew.vue?vue&type=script&lang=js"
export * from "./SiteDocumentNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports